import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-miss-nation-competition',
  templateUrl: './miss-nation-competition.component.html',
  styleUrls: ['./miss-nation-competition.component.scss']
})
export class MissNationCompetitionComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
